import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { AlertService } from './_services/alert.service';
import { UserService } from './_services/user.service';
import { AlertComponent } from './_directives/alert.component';
import { LoginCustom } from './_helpers/login-custom';
import { Helpers } from '../helpers';
import { AuthDataService } from "./_services/data.service";
import { DataService } from '../_services/data.service';
import { Utilities } from '../_classes/utilities';
import { environment } from '../../environments/environment';
import { KeycloakAuthService } from './_services/keycloak-auth.service';
import { RbacService } from './_services/rbac.service';

@Component({
    standalone: false,
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './templates/login-caligoo.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    currentDomain: string;
    keycloakEnabled: boolean;
    keycloakError: string;

    @ViewChild('alertSignin', { read: ViewContainerRef, static: true }) alertSignin: ViewContainerRef;
    @ViewChild('alertSelectSignin', { read: ViewContainerRef, static: true }) alertSelectSignin: ViewContainerRef;
    @ViewChild('alertSignup', { read: ViewContainerRef, static: true }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass', { read: ViewContainerRef, static: true }) alertForgotPass: ViewContainerRef;

    constructor(private _router: Router,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        private _authDataService: AuthDataService,
        private _dataService: DataService,
        private _alertService: AlertService,
        private _keycloakAuthService: KeycloakAuthService,
        private _rbacService: RbacService,
        private cfr: ComponentFactoryResolver) {
        this.keycloakEnabled = this._keycloakAuthService.isEnabled();
    }

    ngOnInit() {
        this.model.remember = false;

        this.currentDomain = window.location.origin;
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/index';

        if (this.keycloakEnabled) {
            if (this._keycloakAuthService.isAuthenticated()) {
                this.register_login(this._keycloakAuthService.getCurrentUser());
            } else if (this._keycloakAuthService.hasAuthenticatedSession()) {
                setTimeout(() => {
                    this.keycloakError = 'Accesso non autorizzato: è richiesto almeno uno dei ruoli Admin, Helpdesk_L1 o Technical_Support_L2.';
                    this.loading = false;
                }, 1);
            } else {
                this._keycloakAuthService.login(this.buildRedirectUrl(this.returnUrl));
            }
            return;
        }

        // Intercept postback param from external login and follow default login
        let auth: any = this._route.snapshot.queryParams['auth'];

        if (auth) {
            let currentUser: any = JSON.parse(decodeURIComponent(auth));
            localStorage.setItem('external', '1');
            this.register_login(currentUser);
        }
        else {
            let auth_error: any = this._route.snapshot.queryParams['error'];
            let saved_auth_error: any = localStorage.getItem('auth_error');

            if (auth_error && !saved_auth_error) {
                localStorage.setItem('auth_error', auth_error);
                window.location.href = this.buildExternalAuthUrl('logout');
                return;
            }

            if (saved_auth_error) {
                let self = this;
                $.when(self.showAlert('alertSelectSignin')).then(() => {
                    setTimeout(() => {
                        self._alertService.error(Utilities.replaceAll(saved_auth_error, '+', ' '));
                        self.loading = false;
                    }, 1);
                });
            }

            // get return url from route parameters or default to '/'
            this._router.navigate([this.returnUrl]);
        }

        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/default/base/scripts.bundle.js'], true).then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });

        setTimeout(() => {
            Helpers.setLoading(false);
        }, 1000);
    }

    signin() {
        this.loading = true;

        if (this._keycloakAuthService.isEnabled()) {
            this._keycloakAuthService.login(this.buildRedirectUrl(this.returnUrl || '/index'));
            return;
        }

        this._authService.login(this.model.username, this.model.password)
            .subscribe(
            data => {
                let currentUser = JSON.parse(localStorage.getItem('currentUser'));
                this.register_login(currentUser);
            },
            error => {
                this.showAlert('alertSignin');
                this._alertService.error(error);
                this.loading = false;
            });
    }

    register_login(currentUser: any) {

        if (currentUser && currentUser.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            /* this._authDataService.get_data(currentUser.consumer_name, currentUser.token, currentUser.credential_username)
                .subscribe(
                    data => {
                        let settings: any[] = JSON.parse(localStorage.getItem('currentSettings'));
                        if (settings && settings.length > 0) {
                            let homepage = settings.find((obj) => { return obj.name === 'homepage_ang'; });
                            this.returnUrl = (homepage) ? homepage.value : this.returnUrl; */

            this.returnUrl = this._rbacService.firstAllowedRoute();

            this._dataService.get_time_zones();

            this._dataService.get_locations(currentUser.consumer_name, currentUser.token, currentUser.credential_username) // Get locations list
                .subscribe(data => {
                    localStorage.removeItem('auth_error');
                    this._router.navigate([this.returnUrl]);
                });

            this._dataService.get_location_groups(currentUser.consumer_name, currentUser.token, currentUser.credential_username) // Get location groups list
                .subscribe(data => {
                    localStorage.removeItem('auth_error');
                    this._router.navigate([this.returnUrl]);
                });

            localStorage.removeItem('auth_error');
            this.returnUrl = this._rbacService.firstAllowedRoute();

            this._router.navigate([this.returnUrl]);

            /*     }
                else {
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('currentSettings');
                    this.showAlert('alertSignin');
                    this._alertService.error('An error has occured, please try again');
                    this.loading = false;
                }
            },
            error => {
                localStorage.removeItem('currentUser');
                localStorage.removeItem('currentSettings');
                this.showAlert('alertSignin');
                this._alertService.error(error);
                this.loading = false;
            }); */
        }
        else {
            localStorage.removeItem('currentUser');
            localStorage.removeItem('currentSettings');
            if (!this._keycloakAuthService.isEnabled()) {
                this.showAlert('alertSignin');
                this._alertService.error('An error has occured, please try again');
            } else {
                this.keycloakError = 'Keycloak login did not return a valid access token.';
            }
            this.loading = false;
        }
    }

    /* signup() {
        this.loading = true;
        this._userService.create(this.model).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Thank you. To complete your registration please check your email.',
                    true);
                this.loading = false;
                LoginCustom.displaySignInForm();
                this.model = {};
            },
            error => {
                this.showAlert('alertSignup');
                this._alertService.error(error);
                this.loading = false;
            });
    } */
    /*
        forgotPass() {
            this.loading = true;
            this._userService.forgotPassword(this.model.email).subscribe(
                data => {
                    this.showAlert('alertSignin');
                    this._alertService.success(
                        'Cool! Password recovery instruction has been sent to your email.',
                        true);
                    this.loading = false;
                    LoginCustom.displaySignInForm();
                    this.model = {};
                },
                error => {
                    this.showAlert('alertForgotPass');
                    this._alertService.error(error);
                    this.loading = false;
                });
        }
     */
    directLogin() {
        localStorage.removeItem('auth_error');
        this.loading = true;
        window.location.href = this.buildExternalAuthUrl('login');
    }

    showAlert(target) {
        if (!this[target]) {
            return;
        }
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }

    // private buildRedirectUrl(path: string): string {
    //     if (!path) {
    //         return this.currentDomain + '/index';
    //     }

    //     if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
    //         return path;
    //     }

    //     return this.currentDomain + '/' + path.replace(/^\/+/, '');
    // }
    private buildRedirectUrl(path: string): string {
    if (!path) {
        return new URL('index', document.baseURI).href;
    }

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    return new URL(path.replace(/^\/+/, ''), document.baseURI).href;
}

    private buildExternalAuthUrl(action: 'login' | 'logout'): string {
        let appUrl = new URL('login/', document.baseURI).href;
        return `${environment.ConfigEndpoints["login"]}${action}?app_url=${encodeURIComponent(appUrl)}`;
    }
}
